export { CustomerRelationshipsSection } from "./customer-relationships-section";
export { PartnerRelationshipsSection } from "./partner-relationships-section";
export { NoRelationshipsSection } from "./no-relationships-section";
export { InternalRelationshipsSection } from "./internal-relationships-section";
